<cc-top-bar [title]="('WEBHOOKS.LABEL' | translate)">
  <cc-top-bar-item>
    <a [routerLink]="['/webhooks/new']">
      <i class="material-icons">add</i>
      <span translate>WEBHOOKS.ADD</span>
    </a>
  </cc-top-bar-item>
</cc-top-bar>
<section>
  <router-outlet></router-outlet>
</section>
